import React, { CSSProperties, ReactElement, useMemo } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import classNames from 'classnames';

type IProps = {
	id: string;
	children: ReactElement;
};

const SortableChart = ({ id, children }: IProps) => {
	const {
		attributes,
		listeners,
		setNodeRef,
		transform,
		isDragging,
		transition,
		active,
	} = useSortable({ id });

	const isActive = useMemo(() => isDragging || active?.id === id, [isDragging, active, id]);

	const itemStyle: CSSProperties = useMemo(() => ({
		transform: CSS.Transform.toString(transform),
		transition,
		border:    isActive ? '2px dashed hsl(var(--blue-500))' : 'none',

	}), [isActive, transform, transition]);

	const className = classNames(
		'flex w-full h-full',
		'focus:outline-0',
		!isActive && 'focus-within:ring-1 focus-within:ring-offset-2 focus-within:ring-blue-500',
	);

	return (
		<div className={className}
			style={itemStyle}
			ref={setNodeRef}
			{...attributes}
			{...listeners}
		>
			{isActive ? (
				<div className="w-full h-full" />
			) : (
				children
			)}
		</div>
	);
};

export default SortableChart;
